"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const wallet_1 = require("../wallet");
const nearAPI = __importStar(require("near-api-js"));
const config_1 = __importDefault(require("./config"));
class NearWallet {
    constructor() {
        this.walletOptions = {
            signInRequired: true,
            type: wallet_1.WalletType.Browser,
            changableNetwork: true,
        };
        this.networkName = 'testnet';
        this.iconUrl = '';
    }
    getWalletId() {
        return 'near-wallet';
    }
    getWalletName() {
        return 'NEAR Wallet';
    }
    initialize(walletEventsHandler) {
        return __awaiter(this, void 0, void 0, function* () {
            this.walletEventsHandler = walletEventsHandler;
            yield this.initNear();
        });
    }
    finalizer() {
        return __awaiter(this, void 0, void 0, function* () {
            throw new Error("Method not implemented.");
        });
    }
    connectToContract(contractData) {
        return __awaiter(this, void 0, void 0, function* () {
        });
    }
    getAccountAddress() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            return (_a = this.walletAccount) === null || _a === void 0 ? void 0 : _a.getAccountId();
        });
    }
    setNetwork(networkName) {
        return __awaiter(this, void 0, void 0, function* () {
            this.networkName = networkName;
            yield this.initNear();
            yield this.walletEventsHandler();
        });
    }
    isSignedIn() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.walletAccount.isSignedIn();
        });
    }
    signIn(contractData) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.walletAccount.requestSignIn(contractData["token"], 'Who was');
        });
    }
    signOut() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.walletAccount.signOut();
        });
    }
    trustedMint(tokenId, salt, signature) {
        return __awaiter(this, void 0, void 0, function* () {
            throw new Error("Method not implemented.");
        });
    }
    isTokenExists(tokenId) {
        return __awaiter(this, void 0, void 0, function* () {
            throw new Error("Method not implemented.");
        });
    }
    isTokenOwner(tokenId) {
        return __awaiter(this, void 0, void 0, function* () {
            throw new Error("Method not implemented.");
        });
    }
    /* ----- */
    initNear() {
        return __awaiter(this, void 0, void 0, function* () {
            this.config = (0, config_1.default)(this.networkName);
            const prefix = `${this.networkName}-near-api-js:keystore:`;
            this.near = yield nearAPI.connect(Object.assign({ deps: { keyStore: new nearAPI.keyStores.BrowserLocalStorageKeyStore(window.localStorage, prefix) } }, this.config));
            this.walletAccount = new nearAPI.WalletAccount(this.near, this.networkName);
        });
    }
}
exports.default = NearWallet;
